module.exports = {
	ADD_SENT_MESSAGE(state, payload) {
		state.sent_messages.push(payload);
	}
};